import React from 'react'

import { AnyColor, theme } from '@guiker/components-core'

export interface MessagesBubbleIconProps {
  color?: AnyColor
}

const MessagesBubbleIcon: React.FC<MessagesBubbleIconProps> = ({ color: colorKey }) => {
  const color = theme.palette.getColor(colorKey)

  return (
    <svg width='22' height='22' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12.75 0.750016C10.8788 0.747318 9.04097 1.24543 7.42723 2.19266C5.81349 3.13989 4.48264 4.50172 3.5728 6.13683C2.66295 7.77194 2.20726 9.62074 2.25302 11.4914C2.29877 13.362 2.8443 15.1863 3.833 16.775L0.75 23.25L7.224 20.167C8.6047 21.0255 10.1659 21.5515 11.7846 21.7038C13.4032 21.8561 15.0351 21.6305 16.5517 21.0446C18.0683 20.4587 19.4281 19.5287 20.524 18.3278C21.62 17.1269 22.422 15.6878 22.8671 14.1241C23.3121 12.5604 23.3879 10.9147 23.0886 9.3167C22.7892 7.71868 22.1229 6.21201 21.142 4.9154C20.1612 3.61879 18.8926 2.56766 17.4363 1.84483C15.9801 1.122 14.3758 0.747216 12.75 0.750016V0.750016Z'
        stroke={color || 'currentColor'}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export { MessagesBubbleIcon }
